<template>
  <section id="faq" class="container mx-auto px-4 py-10 md:py-16">
    <div class="max-w-3xl mx-auto mb-8 md:mb-16 text-center">
      <h2 class="text-3xl md:text-4xl font-bold text-navy mb-6">{{ t('faq.title') }}</h2>
      <div class="w-24 h-1 bg-leaf mx-auto mb-6 rounded-full"></div>
      <p class="text-lg text-muted-foreground">
        {{ t('faq.subtitle') }}
      </p>
    </div>
    <Accordion type="single" collapsible class="max-w-3xl mx-auto space-y-4">
      <AccordionItem
        v-for="(item, index) in faqItems"
        :key="index"
        :value="`item-${index}`"
      >
        <AccordionTrigger class="font-semibold text-xl">{{ item.question }}</AccordionTrigger>
        <AccordionContent class="text-foreground/80">{{ item.answer }}</AccordionContent>
      </AccordionItem>
    </Accordion>
  </section>
</template>

<script setup lang="ts">
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@acme/ui";
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import { useBlueberry } from "@acme/api";

const { t, tm } = useI18n();
const blueberry = useBlueberry().getBlueberry();

const faqItems = computed(() =>
  (tm("faq.items") as Array<{ question: string; answer: string }>).map(
    (item, index) => ({
      ...item,
      answer:
        index === 0 && !blueberry.value.success
          ? t("faq.priceUnavailable")
          : t(`faq.items[${index}].answer`, {
              price: blueberry.value.success
                ? blueberry.value.content.price
                : "",
            }),
    })
  )
);
</script>
